import axios from "axios";

const API = axios.create({
  baseURL: "https://test.frendrops.in/api/",
});

export default API;